<template>
  <div class="page">
    <el-steps v-if="$route.query.step" simple :active="1" finish-status="success" slot="header" style="width: 100%; max-width: 800px; margin-bottom: 20px;">
      <el-step title="创建页面"></el-step>
      <el-step title="制作页面"></el-step>
    </el-steps>
    <div class="box-preview">
      <template v-for="(row, index) in page">
        <div
          :class="`item-component ${currentKey === row.key && 'active'}`"
          @click="currentKey = row.key"
          :key="row.key"
        >
          <div class="box-control">
            <i class="el-icon-arrow-up" @click.stop="handleUp(index)" v-if="index - 1 >= 0" />
            <i class="el-icon-arrow-down" @click.stop="handleDown(index)" v-if="index + 1 < page.length" />
            <i class="el-icon-delete" @click.stop="handleDelete(index)" />
          </div>
          <component
            :is="row.name"
            :links="links"
            :tabModules="tabModules"
            :showController="currentKey === row.key"
            v-model="row.data"
          />
        </div>
      </template>
      <div class="box-components">
        <h5 class="box-title">选择组件</h5>
        <div class="content">
          <div class="item" v-for="item in components" :key="item.name" @click="handleAddComponent(item)">{{ item.title }}</div>
        </div>
      </div>
      <el-button class="btn-save" type="primary" @click="handleSave">保存</el-button>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash';
import uuid from 'uuid/v4';
import components from './components/custom-components';

@Component({
  components: _.mapValues(_.keyBy(components, 'name'), 'component')
})
export default class CustompagesEdit extends Vue {

  components = components;
  page = [];
  links = [];
  tabModules = [];
  currentKey = '';

  async mounted() {
    this.fetchData();
  }

  async fetchData() {
    const [links, { data: tabModules }, initData] = await Promise.all([
      this.$request.get('/page_group_links'),
      this.$request.get('/tab_modules', { params: { per_page: 100 } }),
      this.$request.get(`/custom_pages/${this.$route.params.id}`)
    ]);
    this.page = JSON.parse(initData.components) || [];
    this.tabModules = tabModules.map(({ id, key, name }) => ({ id, key, name }));
    this.links = _.map(links, (groupValue, groupLable) => {
      return {
        label: groupLable,
        options: _.map(groupValue, (value, label) => ({ value, label }))
      }
    });
  }

  handleAddComponent({ component, title, name }) {
    const newComponent = {
      component,
      name,
      title,
      key: uuid()
    }
    this.page.push(newComponent);
    this.currentKey = newComponent.key;
  }

  handleDelete($index) {
    this.page.splice($index, 1);
  }

  handleUp($index) {
    const current = this.page.splice($index, 1)[0];
    this.page.splice($index - 1, 0, current);
  }

  handleDown($index) {
    const current = this.page.splice($index, 1)[0];
    this.page.splice($index + 1, 0, current);
  }

  async handleSave() {
    await this.$autoLoading(
      this.$request.put(`/custom_pages/${this.$route.params.id}`, {
        components: JSON.stringify(this.page)
      })
    );
    this.$message.success('更新成功');
    this.fetchData();
  }
}
</script>

<style lang="scss" scoped>

  .page {
    padding-bottom: 150px;
    overflow-y: auto;
  }

  .btn-save {
    margin: 15px;
  }

  .box-preview {
    width: 375px;
    border: 1px solid $border-light;
    overflow: visible;
    background: #fff;
  }

  .item-component {
    position: relative;
    min-height: 80px;
    border: 1px dashed $border-light;

    &.active {
      border-color: $primary;
    }

    .box-control {
      position: absolute;
      top: 5px;
      right: 0;
      display: flex;
      z-index: 99;

      i {
        cursor: pointer;
        margin-right: 5px;
        color: black;
        background: #ffffff7d;
      }
    }
  }

  .box-components {
    padding-left: 15px;
    padding-top: 15px;

    .box-title {
      margin: 15px 0;
      font-size: 18px;
    }

    .content {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
    }

    .item {
      font-size: 14px;
      text-align: center;
      min-width: 80px;
      padding: 6px 8px;
      border: 1px solid $border-light;
      cursor: pointer;
      margin-right: 15px;
      margin-bottom: 15px;
    }
  }
</style>

